
import React from 'react';
import AMCConstants from './AMCConstants';
import ZProps from './zprops';
import ZLog from './zlog';
import AMC from './AMC';
import { APP } from './App';
import { AUTH } from './AMCAuth';
import { AutomaticJoiningFormMini } from './AMCAuth';
import { ROUTER } from "./AMCRouter";
import ZUtil from './zutil';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFire, faHome, faUser, faDatabase, faBrain, faPlay, faPeace, faUserNinja, faBars } from '@fortawesome/free-solid-svg-icons'
import ZooGenericTrackedButton from './ZooGenericTrackedButton';
import { AutomaticSigninPopup } from './AMCAuth';
import PleaseStandBy from "./PleaseStandBy";
import AMCBanners from './AMCBanners';
import ZNinja from './ZNinja';
import { ZooTopTaskBar } from './ZooTop';


export var ZOO = null;

export default class Zoo extends React.Component {
	constructor(props) {
		super(props);
		let cookies = ZUtil.getCandy("zoo");
		cookies = cookies ? JSON.parse(cookies) : {};
		this.state = { expanded: cookies.expanded }; 
		ZOO = this;
	}
	componentDidMount() {
		this.listener = ZProps.addListener("ninja", (name, value, oldvalue) => {
			this.forceUpdate();
		});
	}
	componentWillUnmount() {
		ZProps.removeListener(this.listener);
	}
	showItemProfile(item, update_url) {
		this.setState({ item: item, view: AMCConstants.ZOO_VIEW_PROFILE });
		if (update_url) {
			ROUTER.pushRoute(item ? "/" + item.uri : "/");
		}
		return false;
	}
	toggleMainMenu(flag) {
		this.setState({mainmenu: flag === true || !this.state.mainmenu});
	}
	toggleUserMenu = (flag) => {
		APP.showPopup(flag === true || !this.state.usermenu ? <ZooUserAccountMenu /> : null);
		this.setState({usermenu: flag === true || !this.state.usermenu});
	}
	toggleUploadMenu(flag) {
		this.setState({uploadmenu: flag === true || !this.state.uploadmenu});
	}
	closeMenus(event) {
		if (this.state.mainmenu || this.state.usermenu) {
			this.setState({ mainmenu: false, usermenu: false });
		}
	}
	// Currently sets text in search textfield
	setTitle(title) {
		this.setState({ title: title });
	}
	setView(view) {
		this.closeMenus();
		this.setState({view: view === ZProps.get("user").uri ? AMCConstants.ZOO_VIEW_MYZOO : view, target_user_uri: null});
		ROUTER.softPushRoute("/" + view);
	}	
	show(component) {
		this.setState({payload: component});
	}
	onScroll(event) {
		ZProps.sett("onScroll", event.target, true);
	}
	onExpand(expanded) {
		let cookies = ZUtil.getCandy("zoo");
		cookies = cookies ? JSON.parse(cookies) : {};
		cookies.expanded = expanded;
		ZUtil.setCandy("zoo", JSON.stringify(cookies));
		this.setState({ expanded: expanded });
		document.getElementById("amc-main-scroller").scrollTop = 0;
	}
	expandThisPageOnly() {
		this.setState({ expanded: true });
	}
	isExpanded() {
		return this.state.expanded;
	}
	render() {
		let { search } = this.props;
		let { expanded } = this.state;
		ZLog.debug("RENDER zoo");
		var p = this.props;
		var payload = p.children; 
		if (!payload) {
			return <PleaseStandBy />;
		}
		let path = ZProps.get("path");
		let search_keywords = search ? path.substring("/search/".length).replace(/[+]/g, " ").replace(AMCConstants.SEARCH_SPECIAL_FOCUS_CHAR, ":") : this.state.title; // if you setTitle make sure to setTitle null in WillUnmount 
		let topbar = ZProps.get("beta") ? '' : <ZooToolBar toggleMainMenu={this.toggleMainMenu.bind(this)} toggleUserMenu={this.toggleUserMenu} defaultValue={search_keywords} />;
//		let footer = (path.startsWith("/zoo/") && expanded) || ZProps.get("beta") ? '' : <ZooFooter />
//		let footer = (path.startsWith("/zoo/") && expanded) ? '' : <ZooFooter />
		let { banner, bannerbottom } = AMCBanners.getBanner(this);
		if (banner || (!path.startsWith("/zoo/") && !path.startsWith("/admin"))) {
			expanded = false;
		}
		if (ZProps.get("path") === "/zoo") {
			expanded = true;
		}
		let footer = expanded ? '' : <ZooFooter />
		//let has_taskbar = (!!ZProps.get("queryparms") || path === "/") && !ZProps.get("beta");
		let has_taskbar = (path.startsWith("/zoo/") || path === "/") && !ZProps.get("beta");
		if (ZProps.get("beta")) {
			bannerbottom = "5em";
		}
		let ninja = ZProps.get("ninja");
		ninja = ninja ? <ZNinja context={ninja} /> : null;
		let h_scrollable = path === "/-/pricing";
		return (
			<div className={"Zoo" + (path === "/" ? " ZooFrontPage" : expanded ? " ZooExpandedContent" : "") + (has_taskbar ? " ZooExpandedContentWithTaskBar" : "")} onClick={this.closeMenus.bind(this)}>
				{topbar}
				<div className={"ZooBannerArea" + (ninja ? " ZooBannerAreaWithNinja" : "") + (h_scrollable ? " ZooBannerAreaScrollable" : "")} id="amc-main-scroller" onScroll={this.onScroll.bind(this)}> 
					{banner}
					<div className="ZooPage" style={{top: bannerbottom}}>
						<div className={"ZooPageContent" + (expanded ? " ZooPageContentExpanded" : "")}>
							{payload}
						</div>
						{footer}
					</div>
				</div>
					{ ninja ? 
						<div className="ZNinjaContainer">
							{ninja}
						</div>
					: '' }
				{ this.state.mainmenu ? <MainMenu /> : '' }
				{ has_taskbar ? <ZooTopTaskBar /> : '' }
			</div>
		);
	}
}

class ZooFooter extends React.Component {
	constructor(props) {
		super(props);
		this.state = {};
	}
	render() {

		return (
			<div className="ZooFooter">
			<ul>
				<li>Copyright Software Farm, Inc.</li>
			</ul>
			<ul>
				<li><a href="mailto:contact@automatic.ai">contact</a></li>
				<li><a href="/-/about" onClick={ROUTER.pushRoute.bind(ROUTER, "/-/about")}>About</a></li>
				<li><a href="/-/terms" onClick={ROUTER.pushRoute.bind(ROUTER, "/-/terms")}>Terms</a></li>
				<li><a href="/-/privacy" onClick={ROUTER.pushRoute.bind(ROUTER, "/-/privacy")}>Privacy</a></li>
				<li><a href="/-/pricing" onClick={ROUTER.pushRoute.bind(ROUTER, "/-/pricing")}>Pricing</a></li>
				<li><a href="/docs/index.html">Docs</a></li>
				<li><a href="https://join.slack.com/t/automaticai/shared_invite/zt-fp8r10zm-VdgMhsQlD0zNg1YKAyOR2w" target="_blank" rel="noopener noreferrer">Slack</a></li>
				<li><a href="/blog/index.html">Blog</a></li>
				<li><a href="https://omg.ai">OMG.ai</a></li>
				<li><a href="https://github.com/automatic-dot-ai">GitHub</a></li>
				<li><a className="BLM" href="https://colorofchange.org/" target="_blank" rel="noopener noreferrer">Black Lives Matter</a></li>
			</ul>
			</div>
		)
	}
}

export class ZooToolBar extends React.Component {
	constructor(props) {
		super(props);
		this.state = {};
	}
	componentDidMount() {
		this.resizeHandler = this.onResize.bind(this);
		window.addEventListener('resize', this.resizeHandler);
		this.listener = ZProps.addListener("ninja", (name, value, oldvalue) => {
			this.forceUpdate();
		});
		this.listener2 = ZProps.addListener("theme", (name, value, oldvalue) => {
			this.forceUpdate();
		});
		this.componentDidUpdate();
	}
	componentWillUnmount() {
		window.removeEventListener('resize', this.resizeHandler);
		ZProps.removeListener(this.listener);
		ZProps.removeListener(this.listener2);
	}
	onResize() {
		this.forceUpdate();
	}
	onSearchKey(e) {

		if (e.key === 'Enter') {
			this.search(e.target.value);
		}
	}
	onSearchButton(textfield_id) {
		this.search(document.getElementById(textfield_id).value)
	}
	search(keywords) {
		keywords = keywords.trim();
		let uri = ZUtil.urlify(keywords.replace(":", AMCConstants.SEARCH_SPECIAL_FOCUS_CHAR).replace(/\//g, "-"));
		ZProps.set("searching", keywords);
		ROUTER.pushRoute("/search/" + uri);

	}
	toggleMainMenu(event) {
		ZUtil.eatEvent(event);
		this.props.toggleMainMenu();
	}
	toggleUserMenu = (event) => {
		ZUtil.eatEvent(event);
		this.props.toggleUserMenu();
	}
	render() {
		var user = { avatar: "/images/default_avatar.png" };
		user = ZProps.get("user");
		var logged_in = user.plan !== "guest";
		let { search, defaultValue } = this.props;
		let path =  ZProps.get("path");


		defaultValue = defaultValue || "";
		let slogan =  "Find and use intelligent services... or build and deploy your own";
		let ninja = ZProps.get("ninja");
		// let ninja_bot = <FontAwesomeIcon icon={faStreetView} />
		let default_user = <img src="/images/default_avatar.png" alt="awesome human" />;
		let darktheme = path === "/zoo" && (ZProps.get("theme") || {}).dark;
console.log("ZOO ZProps.get(darktheme)=" + darktheme);
		return (
			<div className="WZooTopBar">
				<span className="ZooHamburger"  alt="main menu" onClick={this.toggleMainMenu.bind(this)}>
{/*					<img src="/images/hamburger.png" alt="main menu" onClick={this.toggleMainMenu.bind(this)}/> */}
					<FontAwesomeIcon icon={faBars} />
				</span>
				<span className="ZooAppLogo">
					<a href="/" onClick={ROUTER.pushRoute.bind(ROUTER, "/zoo")} ><img alt="logo" src={ darktheme ? AMCConstants.DARKTHEME_LOGO : AMCConstants.LOGO } /></a>
				</span>
				<span className={"ZooSearchContainer" + (logged_in ? "" : " ZooSearchContainerNotSignedIn") + (ninja ? " XXXZooSearchContainerNinjaOpen" : "")} id="zoopage_search_container">
					<input type="text" key={defaultValue} id="zoopage_search_field" className="ZooSearchField"  onKeyUp={this.onSearchKey.bind(this)} defaultValue={defaultValue} placeholder={ search || slogan } />
					<span className="ZooSearchButton" id="zoo-topbar-search-button" onClick={this.onSearchButton.bind(this, "zoopage_search_field")}>
						<img alt="search" src= "/images/searchd.png" />
					</span>
				</span>
				<span className="ZooToolBarRightSide">
{/*					<button className={"ZooToolBarAvatar" + (ninja ? " ZooNinjaToolbarButtonSelected" : "")} title={"Summon the ninja bot"} onClick={APP.toggleNinja}>{ninja_bot}</button> */}
					{ !logged_in && path === "/" ?
						<span className="ZooToolBarSignIn" onClick={e => { APP.showPopup(<AutomaticSigninPopup />) }}>sign in</span>
					: 
						<button className="ZooToolBarAvatar" title={"Hi " + user.name + (user.uri !== user.group ? " (@" + user.group + ")" : "") +  "!"} onClick={ e => { logged_in ? this.toggleUserMenu(e) : APP.showPopup(<AutomaticSigninPopup />) } }>{user.avatar ? <img alt="user avatar" src={user.avatar} /> : default_user }</button>
					}
					{ !logged_in && path !== "/" && path !== "/signin" && path !== "/beta"  && !path.startsWith("/account/forgot") ? 
						<AutomaticJoiningFormMini /> 
					: '' } 
				</span>
			</div>
		)
	}
	componentDidUpdate() {
		if (document.getElementById("zoo-topbar-search-button")) {
			let btnwidth = document.getElementById("zoo-topbar-search-button").getBoundingClientRect().width;
			let boxwidth = document.getElementById("zoopage_search_container").getBoundingClientRect().width;
			document.getElementById("zoopage_search_field").style.width = (boxwidth - btnwidth) + "px";
		}
	}
}

/*
class WatchButton extends React.Component {
	watch() {
		this.props.onWatch(this.props.uri);
	}
	unwatch() {
		this.props.onUnWatch(this.props.uri);
	}
	render() {
		var p = this.props;
		return (
			<div className="ZooWatchButton" onClick={this.watch.bind(this)} aria-label="Watch this" title={"Watch " + p.uri}><button><span className="ZooWatchButtonLeftSide BUTTON_BACKGROUND_COLOR"><img alt="watch" src="/images/watch-button-icon-4.png" />Watch</span><span className="ZooWatchButtonRightSide" aria-label={p.watchers + " people watching this"}>{p.watchers || 1}</span></button></div>
		)
	}
}
class UploadButton extends React.Component {
	constructor(props) {
		super(props);
		this.state = {};
	}
	render() {
		return (
			<button className="ZooUploadButton" title="Upload data" onClick={ROUTER.pushRoute.bind(ROUTER, "/zoo/upload")}><span className="ZooUploadButtonLeftSide"><img alt="upload" src="/images/upload-button-icon-6.png" /></span></button>
		)
	}
}
*/
class MainMenu extends React.Component {
	constructor(props) {
		super(props);
		this.state = {};
	}
	componentDidMount() {
		AMC.getHistory((err, list) => {
			this.setState({ history: (list || []).reverse().slice(0, 7) });
		});
	}
/*
	goHome() {
		ROUTER.pushRoute("/");
	}
*/
	render() {
		let { history } = this.state;
		let user = ZProps.get("user");
		let recent = (history || []).map( h => <MainMenuItem key={h.uri} label={h.name} title={h.owner + "'s " + h.name} link={"/zoo/" + h.uri} fonticon={<FontAwesomeIcon icon={faPlay} />} /> );
		// ninja was faStreetView
		return (
			<div className="MainMenu MENU_BORDER_COLOR" onClick={ZUtil.eatEvent}>
				<MainMenuItem label="Home" fonticon={<FontAwesomeIcon icon={faHome} />} link="/zoo" style={{fontWeight: "bold"}} />
{/*				<MainMenuItem label={<ZooGenericTrackedButton label="Demos" tracking_uri={AMCConstants.DEMOS_TRACKING_URI} link={AMCConstants.DEMOS_URI} />} fonticon={<FontAwesomeIcon icon={faDesktop} />} link={null} /> */}
				<MainMenuItem label={<ZooGenericTrackedButton label="Leaderboards" tracking_uri={AMCConstants.LEADERBOARDS_TRACKING_URI} link={AMCConstants.LEADERBOARDS_URI} />} fonticon={<FontAwesomeIcon icon={faFire} />} link={null} />
				<MainMenuItem label={<ZooGenericTrackedButton label="Got data?" tracking_uri={AMCConstants.GOT_DATA_TRACKING_URI} link={AMCConstants.GOT_DATA_URI} />} fonticon={<FontAwesomeIcon icon={faDatabase} />} link={null} />
				<MainMenuItem label={<ZooGenericTrackedButton label="Got model?" tracking_uri={AMCConstants.GOT_MODEL_TRACKING_URI} link={AMCConstants.GOT_MODEL_URI} />} fonticon={<FontAwesomeIcon icon={faBrain} />} link={null} />
				<MainMenuItem label={<ZooGenericTrackedButton label="Help Bot" tracking_uri={AMCConstants.NINJA_TRACKING_URI} onClick={e => { APP.toggleNinja(true); ZOO.toggleMainMenu() } } track_clicks={true} />} fonticon={<FontAwesomeIcon icon={faUserNinja} />} link={null} />
				<MainMenuItem label="Plans and pricing" link={AMCConstants.PRICING_URI} fonticon={<FontAwesomeIcon icon={faPeace} />} />
				<MainMenuItem label="My profile" fonticon={<FontAwesomeIcon icon={faUser} />} link={"/" + ZProps.get("user").uri} />
				<MainMenuItem label="My Account" link={"/account"} />
				<MainMenuItem label="My Billing" link={"/billing"} />
				{ user.plan === "business" ? 
					<MainMenuItem label="Members" link={"/organizations/" + user.uri} />
				:
					<MainMenuItem label="My Organizations" link={"/organizations"} />
				}
{/*				<MainMenuSeparator /> */}
				<MainMenuItem label="Feedback and Support" link={"https://join.slack.com/t/automaticai/shared_invite/zt-fp8r10zm-VdgMhsQlD0zNg1YKAyOR2w"} style={{color: "#07f"}} />
				{recent}
					
			</div>

		);

	}
}
export class MainMenuSeparator extends React.Component {
	constructor(props) {
		super(props);
		this.state = {};
	}
	render() {
		return <div className="MainMenuItemSeparator"></div>
	}
}
export class MainMenuItem extends React.Component {
	constructor(props) {
		super(props);
		this.state = {};
	}
	render() {
		let { link, selected, onClick, label, fonticon, icon, title, style } = this.props;
		return (
			<div className={"MainMenuItem" + (selected ? " MainMenuItemSelected" : "") + (typeof label === "string" && label.toLowerCase() !== "home" ? " MainMenuItemSlim" : "")}>
			{ typeof label === "string" ?
				(link && link.startsWith("http") ?
				<a href={link} title={title || ""} style={style}  target="_blank" rel="noopener noreferrer nofollow">
					<span className="MainMenuItemIcon">{fonticon ? fonticon : icon ? <img alt={label} src={icon} /> : '' }</span>
					<span className="MainMenuItemLabel">{label}</span>
				</a>
				:
				<a href={link} title={title || ""} style={style} onClick={onClick || (link ? ROUTER.pushRoute.bind(ROUTER, link[0] === "/" ? link : "/" + link) : null)}>
					<span className="MainMenuItemIcon">{fonticon ? fonticon : icon ? <img alt={label} src={icon} /> : '' }</span>
					<span className="MainMenuItemLabel">{label}</span>
				</a>
				) :
				<div>
					<span className="MainMenuItemIcon">{fonticon ? fonticon : icon ? <img alt={label} src={icon} /> : '' }</span>
					<span className="MainMenuItemLabel">{label}</span>
				</div>
				}
			</div>
		)
	
	}
}
/*
	USER
		name
		username
		# followers
		role
		avatar
		loggedin ?
	USERDATA
		following
		watching
		owner
		stars
		likes
		dislikes

*/
export class ZooUserAccountMenu extends React.Component {
	constructor(props) {
		super(props);
		this.state = {};
	}
	render() {
		var user = ZProps.get("user");
		return (
			<div className="AMUserAccountMenu" onClick={ZUtil.eatEvent}>
				<div className="AMUserAccountMenuTopRow ClearFix">
					<img alt="avatar" src={user.avatar || "/images/default_avatar.png"} />
					<h3>{user.name}</h3>
					<h4>{user.uri}</h4>
					{ user.uri !== user.group ? <h4>@{user.group}</h4> : '' }
					<h5>{user.plan || "guest"}</h5>
					<h5>{ ZUtil.toShortFloat(AMC.getCapacity(ZProps.get("usergroup"))) }</h5>
					{ user.plan !== "guest" ? <h5 className="ThankYou">(Thank you!)</h5> : '' }

				</div>
				<div>
					<button className="AMUserAccountMenuDetailsButton"><a href={"/" + user.uri} onClick={ROUTER.pushRoute.bind(ROUTER, "/" + user.uri)}>Your Profile</a></button>
					<button className="AMUserAccountMenuDetailsButton"><a href={"/account"} onClick={ROUTER.pushRoute.bind(ROUTER, "/account")}>Your Account</a></button>
				</div>
				<div className="AMUserAccountMenuRow ClearFix">
					<button className="AMUserAccountMenuUpgradeButton"><a href={AMCConstants.PRICING_URI} onClick={ROUTER.pushRoute.bind(ROUTER, AMCConstants.PRICING_URI)}>Upgrade</a></button>
					<button onClick={(e) => { AUTH.signOut(); APP.closePopups(); this.forceUpdate() }} className="AMUserAccountMenuSignOutButton">Sign out</button>
				</div>
			</div>
		)
	}
}














// WEBPACK FOOTER //
// ./src/zoo.js